"use client"

import { useState, useEffect } from "react"
import "./home-client-v2.css"
import API from "../services/api"

// Translation system
const translations = {
  fr: {
    // Hero section
    welcome: "Bienvenue à IBIS Sfax",
    scrollDown: "DÉFILER VERS LE BAS",
    livretaccueil: "A propos de l'hôtel",
    // Main banners
    coffeeCup: "UNE TASSE DE CAFÉ",
    forYourReview: "POUR VOTRE AVIS",
    clickImageReview: "Cliquez sur l'image et laissez votre avis",
    discoverOur: "DÉCOUVREZ NOS",
    restaurants: "RESTAURANTS",
    exploreSpecialties: "Explorez nos spécialités culinaires et notre gastronomie",
    relaxAt: "DÉTENDEZ-VOUS À",
    ourSkyLounge: "NOTRE SKY LOUNGE",
    panoramicView: "Profitez d'une vue panoramique avec des boissons premium",

    // Feature cards
    ibismusic: "IBIS MUSIC",
    boissonsetnourritures: "Nourriture et boissons",
    serviceadditional: "SERVICES ADDITIONNELS",
    nosplaylist: "Nos playlists",
    plandesfax: "Se déplacer",
    presse: "Presse",
    encas: "ENCAS",
    bar: "Bar",
    petitdejeuner: "Petit-déjeuner",
    seminaire: "Business",
    lesecogestes: "Politique de développement durable et écogestes",

    eat: "Restaurant Ibis",
    drink: "Bar",
    relax: "Sky Lounge",
    wellness: "in BALANCE BY IBIS",
    events: "Événements",
    services: "Services",
    roomService: "Restauration en chambre",
    business: "Meeting AT Ibis",
    feedback: "Avis",

    environmentalPolicy: "Politique environnementale",
    sustainablePractices: "Pratiques durables pour un avenir meilleur",

    // Navigation
    home: "Accueil",
    bar: "Bar",
    spa: "Spa",

    // Popup
    specialOffers: "Offres Spéciales Ibis",
    discoverPromotions:
      "Découvrez nos promotions exclusives et profitez de réductions exceptionnelles sur votre séjour. Réservez maintenant et économisez jusqu'à 30% !",
    discoverOffers: "Découvrir les offres",

    // Footer
    allRightsReserved: "Tous droits réservés",
    createdBy: "Créé par",
    giveUsFeedback: "Donnez nous votre avis",
    skipCleans: "Skip the clean",
    ecogeste: "Ecogeste",
  },

  en: {
    // Hero section
    welcome: "Welcome to IBIS Sfax",
    scrollDown: "SCROLL DOWN",

    // Main banners
    coffeeCup: "A CUP OF COFFEE",
    forYourReview: "FOR YOUR REVIEW",
    clickImageReview: "Click on the image and leave your review",
    discoverOur: "DISCOVER OUR",
    restaurants: "RESTAURANTS",
    exploreSpecialties: "Explore our culinary specialties and gastronomy",
    relaxAt: "RELAX AT",
    ourSkyLounge: "OUR SKY LOUNGE",
    panoramicView: "Enjoy panoramic views with premium drinks",

    // Feature cards
    serviceadditional: "ADDITIONAL SERVICES",
    nosplaylist: "OUR PLAYLISTS",
    plandesfax: "Move around",
    presse: "Press",

    encas: "SNACKS",
    bar: "Bar",
    petitdejeuner: "BREAKFAST",
    seminaire: "Business",
    lesecogestes: "Sustainable development policy and ecogeste",

    giveUsFeedback: "Give us your feedback",
    skipCleans: "Skip the clean",

    eat: "Ibis  Restaurant",
    ibismusic: "ibis MUSIC",
    boissonsetnourritures: "Food and Drinks",

    livretaccueil: "About the hotel",

    drink: "Bar",
    relax: "Sky Lounge",
    wellness: "in BALANCE BY IBIS",
    events: "Events",
    services: "Services",
    roomService: "in-room catering",
    business: "Meeting AT Ibis",
    feedback: "Feedback",

    environmentalPolicy: "Environmental Policy",
    sustainablePractices: "Sustainable practices for a better future",

    // Navigation
    home: "Home",
    bar: "Bar",
    spa: "Spa",

    // Popup
    specialOffers: "Ibis Special Offers",
    discoverPromotions:
      "Discover our exclusive promotions and enjoy exceptional discounts on your stay. Book now and save up to 30%!",
    discoverOffers: "Discover Offers",

    // Footer
    allRightsReserved: "All rights reserved",
    createdBy: "Created by",
    ecogeste: "Ecogeste",
  },

  ar: {
    // Hero section
    welcome: "مرحباً بكم في ايبيس صفاقس",
    scrollDown: "انتقل للأسفل",
    giveUsFeedback: "أعطنا رأيك",
    skipCleans: "تخطي التنظيف",
    // Main banners
    coffeeCup: "فنجان قهوة",
    forYourReview: "لرأيكم",
    clickImageReview: "انقر على الصورة واترك رأيك",
    discoverOur: "اكتشف",
    restaurants: "مطاعمنا",
    exploreSpecialities: "استكشف تخصصاتنا الطهوية وفن الطبخ لدينا",
    relaxAt: "استرخ في",
    ourSkyLounge: "صالة السكاي لاونج",
    panoramicView: "استمتع بإطلالة بانورامية مع المشروبات المميزة",

    // Feature cards
    eat: "مطاعم ايبيس",
    ibismusic: "موسيقى إيبيس",
    boissonsetnourritures: "مشروبات وطعام",

    serviceadditional: "خدمات إضافية",
    nosplaylist: "قوائم التشغيل الخاصة بنا",
    plandesfax: "التنقل",
    presse: "الصحافة",
    encas: "وجبات خفيفة",
    bar: "بار",
    petitdejeuner: "إفطار",
    seminaire: "عمل",
    lesecogestes: "سياسة التنمية المستدامة",
    livretaccueil: "كتيب الترحيب",
    drink: "حانة",
    relax: "صالة سكاي",

    wellness: "منتجع",
    events: "فعاليات",
    services: "خدمات",
    roomService: "خدمة الغرف",
    business: "أعمال",
    feedback: "آراء",

    environmentalPolicy: "السياسة البيئية",
    sustainablePractices: "ممارسات مستدامة لمستقبل أفضل",

    // Navigation
    home: "الرئيسية",
    bar: "البار",
    spa: "السبا",

    // Popup
    specialOffers: "عروض ايبيس الخاصة",
    discoverPromotions: "اكتشف عروضنا الحصرية واستمتع بخصومات استثنائية على إقامتك. احجز الآن ووفر حتى 30%!",
    discoverOffers: "اكتشف العروض",

    // Footer
    allRightsReserved: "جميع الحقوق محفوظة",
    createdBy: "تم إنشاؤه بواسطة",
    ecogeste: "Ecogeste",
  },
}

const languages = [
  { code: "fr", name: "Français", flag: "/images/fr-flag-v2.png" },
  { code: "en", name: "English", flag: "/images/en-flag-v2.png" },
  { code: "ar", name: "العربية", flag: "/images/ar-flag-v2.png" },
]

const HomeClient = () => {
  const [activeCategory, setActiveCategory] = useState(null)
  const [isLoaded, setIsLoaded] = useState(false)
  const [currentTime, setCurrentTime] = useState(new Date())
  const [heroSlide, setHeroSlide] = useState(0)
  const [showPopup, setShowPopup] = useState(false)
  const [currentLanguage, setCurrentLanguage] = useState("fr")
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false)
  const [weatherData, setWeatherData] = useState({ temp: "18°C", loading: true })
  const [currentTopCarouselSlide, setCurrentTopCarouselSlide] = useState(0)
  const [modalConfig, setModalConfig] = useState(null)
  const [isLoadingModal, setIsLoadingModal] = useState(true)
  const [feedbackSlide, setFeedbackSlide] = useState(0)
  const [commitmentSlide, setCommitmentSlide] = useState(0)

  // Get translation function
  const t = (key) => translations[currentLanguage][key] || translations.fr[key] || key

  // Images du diaporama principal
  const heroImages = ["/images/hotel-lobby-v2.png", "/images/hotel-lobby2-v2.png", "/images/hotel-lobby3-v2.png"]

  // Function to fetch weather data for SFAX
  const fetchWeatherData = async () => {
    try {
      const response = await fetch(
        `https://api.openweathermap.org/data/2.5/weather?q=Sfax,TN&appid=b56ce80f1e74973836f961ebb25d8704&units=metric`,
      )
      if (response.ok) {
        const data = await response.json()
        setWeatherData({
          temp: `${Math.round(data.main.temp)}°C`,
          loading: false,
        })
      } else {
        setWeatherData({ temp: "22°C", loading: false })
      }
    } catch (error) {
      setWeatherData({ temp: "22°C", loading: false })
    }
  }

  const fetchModalConfig = async () => {
    try {
      setIsLoadingModal(true)

      const response = await API.get("/special-offer-modal")
      setModalConfig(response.data.data || response.data)
    } catch (error) {
      console.error("Error fetching modal config:", error)
      setModalConfig(null)
    } finally {
      setIsLoadingModal(false)
    }
  }

  useEffect(() => {
    setIsLoaded(true)
    fetchWeatherData()
    fetchModalConfig()

    // Load saved language from localStorage
    const savedLanguage = localStorage.getItem("IBIS-language")
    if (savedLanguage && translations[savedLanguage]) {
      setCurrentLanguage(savedLanguage)
    }

    // Update time every minute
    const timer = setInterval(() => {
      setCurrentTime(new Date())
    }, 60000)

    // Auto-rotate hero images every 7 seconds
    const heroSlideTimer = setInterval(() => {
      setHeroSlide((prev) => (prev + 1) % 3)
    }, 7000)

    const feedbackSlideTimer = setInterval(() => {
      setFeedbackSlide((prev) => (prev + 1) % 2)
    }, 5000)

    const commitmentSlideTimer = setInterval(() => {
      setCommitmentSlide((prev) => (prev + 1) % 3)
    }, 5000)

    // Show popup after 5 seconds
    const popupTimer = setTimeout(() => {
      setShowPopup(true)
    }, 5000)

    return () => {
      clearInterval(timer)
      clearInterval(heroSlideTimer)
      clearInterval(feedbackSlideTimer)
      clearInterval(commitmentSlideTimer)
      clearTimeout(popupTimer)
    }
  }, [])

  const ecogesterBannerSlides = [
    {
      id: "ecogeste",
      title: t("lesecogestes"),
      image: "/images/ecogeste.png",
      navigateTo: () => {
        window.location.href = "/policy-client"
      },
    },
  ]

  useEffect(() => {
    if (!modalConfig || isLoadingModal) return

    console.log("[v0] Modal config loaded:", modalConfig)
    console.log("[v0] showModal:", modalConfig.showModal)
    console.log("[v0] delaySeconds:", modalConfig.delaySeconds)

    if (modalConfig.showModal) {
      const popupTimer = setTimeout(
        () => {
          console.log("[v0] Showing modal after delay")
          setShowPopup(true)
        },
        (modalConfig.delaySeconds || 5) * 1000,
      )

      return () => clearTimeout(popupTimer)
    }
  }, [modalConfig, isLoadingModal])

  useEffect(() => {
    const scrollContainer = document.querySelector(".ibis-v2-feature-cards")
    if (!scrollContainer) return

    let isAutoScrolling = true
    const autoScroll = () => {
      if (!isAutoScrolling) return
      scrollContainer.scrollLeft += 0.5
      if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth - scrollContainer.clientWidth) {
        setTimeout(() => {
          scrollContainer.scrollLeft = 0
        }, 2000)
      }
    }

    const scrollInterval = setInterval(autoScroll, 20)

    const handleMouseEnter = () => {
      isAutoScrolling = false
    }
    const handleMouseLeave = () => {
      isAutoScrolling = true
    }
    const handleScroll = () => {
      isAutoScrolling = false
      setTimeout(() => {
        isAutoScrolling = true
      }, 3000)
    }

    scrollContainer.addEventListener("mouseenter", handleMouseEnter)
    scrollContainer.addEventListener("mouseleave", handleMouseLeave)
    scrollContainer.addEventListener("scroll", handleScroll)

    return () => {
      clearInterval(scrollInterval)
      if (scrollContainer) {
        scrollContainer.removeEventListener("mouseenter", handleMouseEnter)
        scrollContainer.removeEventListener("mouseleave", handleMouseLeave)
        scrollContainer.removeEventListener("scroll", handleScroll)
      }
    }
  }, [])

  // Language change handler
  const changeLanguage = (langCode) => {
    setCurrentLanguage(langCode)
    localStorage.setItem("IBIS-language", langCode)
    setShowLanguageDropdown(false)

    // Update document direction for Arabic
    document.documentElement.dir = langCode === "ar" ? "rtl" : "ltr"
    document.documentElement.lang = langCode
  }

  const formatDate = (date) => {
    const locale = currentLanguage === "ar" ? "ar-TN" : currentLanguage === "en" ? "en-US" : "fr-FR"
    return date
      .toLocaleDateString(locale, {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .replace(/\//g, ".")
  }

  const formatTime = (date) => {
    const locale = currentLanguage === "ar" ? "ar-TN" : currentLanguage === "en" ? "en-US" : "fr-FR"
    return date.toLocaleTimeString(locale, {
      hour: "2-digit",
      minute: "2-digit",
    })
  }

  const scrollToContent = () => {
    const mainContent = document.querySelector(".ibis-v2-main-content")
    if (mainContent) {
      mainContent.scrollIntoView({ behavior: "smooth" })
    }
  }

  const getAllFeatureCards = () => [
    {
      id: "livretaccueil",
      title: t("livretaccueil"),
      image: "/images/livret.jpg",
      fallback: "/placeholder.svg?height=300&width=200&text=Livret",
      path: "/livret-client",
    },
    {
      id: "boissonsetnourritures",
      title: t("boissonsetnourritures"),
      image: "/images/boissonsetnourritures.jpg",
      fallback: "/placeholder.svg?height=300&width=200&text=ibis music",
      path: "/RestaurantBarClient",
    },
    {
      id: "seminaire",
      title: t("seminaire"),
      image: "/images/seminairee.jpg",
      fallback: "/placeholder.svg?height=300&width=200&text=seminaire",
      path: "/seminaires-client",
    },
    {
      id: "petitdejeuner",
      title: t("petitdejeuner"),
      image: "/images/petitdejeuner.jpg",
      fallback: "/placeholder.svg?height=300&width=200&text=petitdejeuner",
      path: "/petitdejeuner-client",
    },
    {
      id: "plandesfax",
      title: t("plandesfax"),
      image: "/images/plansfax.jpg",
      fallback: "/placeholder.svg?height=300&width=200&text=plandesfax",
      path: "/plan-sfax-client",
    },
    {
      id: "presse",
      title: t("presse"),
      image: "/images/presse.jpg",
      fallback: "/placeholder.svg?height=300&width=200&text=presse",
      path: "/PresseClient",
    },
    {
      id: "nosplaylist",
      title: t("nosplaylist"),
      image: "/images/nosplaylist.jpg",
      fallback: "/placeholder.svg?height=300&width=200&text=nosplaylist",
      url: "https://open.spotify.com/user/chpit9s8x82hu2f09dinn96qw?si=S3rSD5obTR27rAm-jTixUw",
    },
    {
      id: "ibismusic",
      title: t("ibismusic"),
      image: "/images/ibismusic.jpg",
      fallback: "/placeholder.svg?height=300&width=200&text=ibis music",
      path: "/ibis-music-client",
    },
  ]

  const feedbackSlides = [
    {
      id: "accor",
      title: "",
      description: "",
      image: "/images/accor.jpg",
      fallback: "/placeholder.svg?height=300&width=200&text=accor",
      link: "https://bit.ly/3kl9s0g",
    },
    {
      id: "skipcleans",
      title: t("skipCleans"),
      description: "",
      image: "/images/skipcleans.png",
      link: "https://bit.ly/3kl9s0g",
    },
  ]

  const handleFeedbackSlideClick = (index) => {
    setFeedbackSlide(index)
  }

  const handleFeedbackPrevSlide = () => {
    setFeedbackSlide((prev) => (prev - 1 + feedbackSlides.length) % feedbackSlides.length)
  }

  const handleFeedbackNextSlide = () => {
    setFeedbackSlide((prev) => (prev + 1) % feedbackSlides.length)
  }

  const handleFeedbackBannerClick = () => {
    const currentSlideData = feedbackSlides[feedbackSlide]
    window.location.href = currentSlideData.link
  }
  const handleCarouselSlideClick = (slide) => {
    if (slide.link) {
      window.location.href = slide.link
    } else if (slide.url) {
      window.open(slide.url, "_blank")
    }
  }

  const getCurrentLanguage = () => languages.find((lang) => lang.code === currentLanguage)

  return (
    <div className={`ibis-v2-app ${currentLanguage === "ar" ? "rtl" : "ltr"}`}>
      {/* Hero Section with Background Slideshow */}
      <div className="ibis-v2-hero">
        <div className="ibis-v2-hero-slideshow">
          {heroImages.map((image, index) => (
            <div
              key={index}
              className={`ibis-v2-hero-slide ${heroSlide === index ? "active" : ""}`}
              style={{ backgroundImage: `url("${image}")` }}
            ></div>
          ))}
        </div>
        <div className="ibis-v2-hero-overlay">
          <div className="ibis-v2-hero-header">
            <div className="ibis-v2-hero-date-time">
              <div className="ibis-v2-hero-date">{formatDate(currentTime)}</div>
              <div className="ibis-v2-hero-separator">|</div>
              <div className="ibis-v2-hero-time">{formatTime(currentTime)}</div>
              <div className="ibis-v2-hero-separator">|</div>
              <div className="ibis-v2-hero-temp">{weatherData.temp}</div>
            </div>
            <div className="ibis-v2-hero-lang" onClick={() => setShowLanguageDropdown(!showLanguageDropdown)}>
              <span>{getCurrentLanguage()?.code.toUpperCase()}</span>
              <img
                src={getCurrentLanguage()?.flag || "/placeholder.svg"}
                alt={getCurrentLanguage()?.name}
                className="ibis-v2-flag"
              />
              {showLanguageDropdown && (
                <div className="language-dropdown">
                  {languages.map((lang) => (
                    <div
                      key={lang.code}
                      className={`language-option ${currentLanguage === lang.code ? "active" : ""}`}
                      onClick={(e) => {
                        e.stopPropagation()
                        changeLanguage(lang.code)
                      }}
                    >
                      <img src={lang.flag || "/placeholder.svg"} alt={lang.name} className="flag-small" />
                      <span>{lang.name}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          <div className="ibis-v2-hero-content">
            <div className="ibis-v2-hero-logo">IBIS</div>
            <div className="ibis-v2-hero-text">{t("welcome")}</div>
          </div>
          <div className="ibis-v2-hero-scroll" onClick={scrollToContent}>
            <div className="ibis-v2-scroll-text">{t("scrollDown")}</div>
            <div className="ibis-v2-scroll-arrow">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12 5L12 19M12 19L19 12M12 19L5 12"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>

      <main className="ibis-v2-main">
        <div className="ibis-v2-main-content">
          <div className="hotel-v2-commitment-slideshow-container">
            <div className="hotel-v2-commitment-slideshow">
              {feedbackSlides.map((slide, index) => (
                <div
                  key={slide.id}
                  className={`hotel-v2-commitment-banner ${feedbackSlide === index ? "active" : ""}`}
                  onClick={handleFeedbackBannerClick}
                  style={{
                    backgroundImage: `url("${slide.image}")`,
                  }}
                >
                  <div className="hotel-v2-commitment-content">
                    <h2>{slide.title}</h2>
                    <p>{slide.description}</p>
                  </div>
                </div>
              ))}
              {/* Left arrow button */}
              <button
                className="ibis-v2-carousel-arrow ibis-v2-carousel-arrow-prev"
                onClick={(e) => {
                  e.stopPropagation()
                  handleFeedbackPrevSlide()
                }}
                aria-label="Previous slide"
              >
                ‹
              </button>
              {/* Right arrow button */}
              <button
                className="ibis-v2-carousel-arrow ibis-v2-carousel-arrow-next"
                onClick={(e) => {
                  e.stopPropagation()
                  handleFeedbackNextSlide()
                }}
                aria-label="Next slide"
              >
                ›
              </button>
            </div>
            <div className="hotel-v2-commitment-dots">
              {feedbackSlides.map((_, index) => (
                <div
                  key={index}
                  className={`hotel-v2-dot ${feedbackSlide === index ? "active" : ""}`}
                  onClick={() => handleFeedbackSlideClick(index)}
                />
              ))}
            </div>
          </div>

          {/* Feature Cards with Horizontal Scroll */}
          <div className="ibis-v2-feature-cards-container">
            <div className="ibis-v2-feature-cards">
              {getAllFeatureCards().map((card) => (
                <div
                  key={card.id}
                  className="ibis-v2-feature-card"
                  onClick={() => {
                    if (card.url) {
                      window.open(card.url, "_blank")
                    } else if (card.path) {
                      window.location.href = card.path
                    }
                  }}
                >
                  <div className="ibis-v2-feature-image">
                    <img
                      loading="lazy"
                      decoding="async"
                      src={card.image || card.fallback}
                      alt={card.title}
                      onError={(e) => {
                        e.currentTarget.src =
                          card.fallback ||
                          `/placeholder.svg?height=300&width=200&text=${encodeURIComponent(card.title)}`
                      }}
                    />
                  </div>
                  <div className="ibis-v2-feature-title">{card.title}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="ibis-v2-carousel-container">
            <div className="ibis-v2-carousel">
              {ecogesterBannerSlides.map((slide) => (
                <div
                  key={slide.id}
                  className="ibis-v2-carousel-slide active"
                  onClick={() => slide.navigateTo()}
                  style={{ cursor: "pointer" }}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      slide.navigateTo()
                    }
                  }}
                >
                  <img
                    loading="lazy"
                    decoding="async"
                    src={slide.image || "/placeholder.svg"}
                    alt={slide.title}
                    onError={(e) => {
                      e.currentTarget.src = `/placeholder.svg?height=300&width=400&text=${encodeURIComponent(slide.title)}`
                    }}
                  />
                  {slide.title && (
                    <div className="ibis-v2-carousel-title">
                      <h3>{slide.title}</h3>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className="ibis-v2-social">
            <a href="https://www.facebook.com/ibissfax" className="ibis-v2-social-icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
            <a href="https://www.instagram.com/ibis_sfax" className="ibis-v2-social-icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" stroke="currentColor" strokeWidth="2" />
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" stroke="currentColor" strokeWidth="2" />
                <line
                  x1="17.5"
                  y1="6.5"
                  x2="17.51"
                  y2="6.5"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </a>
          </div>

          <div className="copyright">
            <p>
              © {new Date().getFullYear()} IBIS Sfax. {t("allRightsReserved")}.
              <br />
              {t("createdBy")}{" "}
              <a href="https://www.itbafa.com" target="_blank" rel="noopener noreferrer">
                <img
                  src="/images/itbafa_logo_dark.png"
                  alt="ITBAFA Logo"
                  style={{ height: "20px", verticalAlign: "middle", marginLeft: "5px" }}
                />
              </a>
            </p>
          </div>
          <br></br>
        </div>
      </main>

      <footer className="ibis-v2-footer">
        <a href="/" className="ibis-v2-nav-item active">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <polyline
              points="9 22 9 12 15 12 15 22"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>{t("home")}</span>
        </a>
        <a href="/RestaurantsMenus-client" className="ibis-v2-nav-item">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2M7 2v20M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>{t("restaurants")}</span>
        </a>
        <a href="/boissons-client" className="ibis-v2-nav-item">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5 12V7a1 1 0 0 1 1-1h4l2-3h2l2 3h4a1 1 0 0 1 1 1v5M5 12l1.5 6h11L19 12M5 12h14"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>{t("bar")}</span>
        </a>

        <a
          href="#"
          className="ibis-v2-nav-item"
          onClick={() =>
            window.open("https://search.google.com/local/writereview?placeid=ChIJHcqBcNMsABMRStyZI95ezEA", "_blank")
          }
        >
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>{t("feedback")}</span>
        </a>
      </footer>

      {modalConfig && modalConfig.showModal && (
        <div className={`ibis-v2-popup-overlay ${showPopup ? "active" : ""}`}>
          <div className="ibis-v2-popup">
            {modalConfig.image && (
              <div className="ibis-v2-popup-image" style={{ backgroundImage: `url("${modalConfig.image}")` }}>
                <button className="ibis-v2-popup-close" onClick={() => setShowPopup(false)}>
                  ×
                </button>
              </div>
            )}
            {!modalConfig.image && (
              <button className="ibis-v2-popup-close-no-image" onClick={() => setShowPopup(false)}>
                ×
              </button>
            )}
            <div className="ibis-v2-popup-content-wrapper">
              <div className="ibis-v2-popup-title">{modalConfig.title}</div>
              <div className="ibis-v2-popup-content">{modalConfig.message}</div>
              <a href="/offres-client#" className="ibis-v2-popup-button">
                {t("discoverOffers")}
              </a>
            </div>
          </div>
        </div>
      )}

      {/* Additional CSS for language dropdown */}
      <style jsx>{`
        .language-dropdown {
          position: absolute;
          top: 100%;
          right: 0;
          background: rgba(0, 0, 0, 0.9);
          border-radius: 8px;
          padding: 8px 0;
          min-width: 150px;
          z-index: 1000;
          backdrop-filter: blur(10px);
        }

        .language-option {
          display: flex;
          align-items: center;
          padding: 8px 16px;
          cursor: pointer;
          transition: background-color 0.2s;
          gap: 8px;
        }

        .language-option:hover {
          background: rgba(255, 255, 255, 0.1);
        }

        .language-option.active {
          background: rgba(255, 255, 255, 0.2);
        }

        .flag-small {
          width: 20px;
          height: 15px;
          object-fit: cover;
          border-radius: 2px;
        }

        .language-option span {
          color: white;
          font-size: 14px;
        }

        .ibis-v2-hero-lang {
          position: relative;
          cursor: pointer;
        }

        .rtl {
          direction: rtl;
        }

        .rtl .ibis-v2-hero-header {
          flex-direction: row-reverse;
          justify-content: space-between;
        }

        .rtl .ibis-v2-hero-date-time {
          order: 2;
        }

        .rtl .ibis-v2-hero-lang {
          order: 1;
        }

        .rtl .language-dropdown {
          left: 0;
          right: auto;
          text-align: right;
        }

        .rtl .ibis-v2-hero-content {
          text-align: right;
        }

        .rtl .ibis-v2-hero-scroll {
          text-align: right;
        }

        .rtl .ibis-v2-banner-content {
          text-align: right;
        }

        .rtl .ibis-v2-commitment-content {
          text-align: right;
        }

        .rtl .ibis-v2-feature-cards {
          direction: rtl;
        }

        .rtl .ibis-v2-footer {
          direction: rtl;
        }

        /* Added styles for close button when no image */
        .ibis-v2-popup-close-no-image {
          position: absolute;
          top: 1rem;
          right: 1rem;
          background: none;
          border: none;
          font-size: 2rem;
          cursor: pointer;
          color: #64748b;
          transition: all 0.3s ease;
          padding: 0;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          transition: all 0.2s ease;
          font-weight: bold;
          z-index: 10;
        }

        .ibis-v2-popup-close-no-image:hover {
          color: #ec4899;
          transform: rotate(90deg);
        }
      `}</style>
    </div>
  )
}

export default HomeClient
